<div class="surface-section flex-column md:align-items-center shadow-1 border-round mb-5 flex flex-wrap justify-between gap-3 md:flex-row">
  <div class="flex items-center">
    <button
      pButton
      pRipple
      icon="pi pi-arrow-left"
      class="p-button-rounded p-button-text mr-3"
      (click)="onBack()"
    ></button>
    <h1 class="m-0 text-3xl font-medium">
      @if (booking?.id) {
        {{ 'booking.detail.title' | translate: { id: booking?.id } }}
      } @else {
        {{ 'booking.detail.newBooking' | translate }}
      }
    </h1>
    @if (booking?.foreign_reservation_code) {
      <span class="text-500 ml-3 mt-[4px]">({{ booking?.foreign_reservation_code }})</span>
    }
  </div>
  <div class="mt-0 flex grow justify-end gap-2 md:ml-auto">
    @if (canLinkChain()) {
      <p-button
        icon="pi pi-link"
        [label]="'booking.chain.link' | translate"
        styleClass="p-button-outlined"
        (click)="onLinkChain()"
      ></p-button>
    }
    <p-button
      icon="pi pi-times"
      [label]="'common.cancel' | translate"
      styleClass="p-button-outlined"
      [disabled]="!hasChanges"
      (click)="onCancel()"
    ></p-button>
    <p-button
      icon="pi pi-check"
      [label]="'booking.detail.save' | translate"
      [loading]="isSaving"
      [disabled]="!hasChanges"
      (click)="onSave()"
    ></p-button>
  </div>
</div>
